import InfoIcon from "../icons/InfoIcon";
import { ReactNode } from "react";
import { Tooltip } from "@mantine/core";

type InfoTooltipProps = {
  label: ReactNode;
  className?: string;
};

/**
 * Renders an InfoIcon that triggers a tooltip.
 */
const InfoTooltip = ({ label, className }: InfoTooltipProps) => {
  return (
    <Tooltip label={label}>
      <InfoIcon className={className} />
    </Tooltip>
  );
};

export default InfoTooltip;
